var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSpeakerCone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_401_16180)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.12443 15.5626V8.74733V8.66982L13.2642 3.00061C13.2642 3.00061 14.8089 2.34179 14.8089 3.70373V11.8421V11.8477V11.8643V11.8809V11.892V11.9307V11.975V11.9805V12.0304V12.0691V12.0913V12.1466V12.1632V12.2186V12.2408V12.2795V12.3293V12.3349V12.3792V12.4179V12.429V12.4456V12.4622V12.4677V20.6062C14.8089 21.9681 13.2642 21.3093 13.2642 21.3093L7.12443 15.6401V15.5626ZM2.99986 8.76394H6.37703V15.6567H2.99986C1.97011 15.6567 1.12305 14.8151 1.12305 13.7799V10.6408C1.12305 9.611 1.96457 8.76394 2.99986 8.76394Z",
    fill: "#66676B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5625 8.52588C17.2234 8.90235 18.4691 10.3861 18.4691 12.1632C18.4691 13.9404 17.2289 15.4241 15.5625 15.8006V8.53142V8.52588Z",
    fill: "#66676B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_401_16180"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakerCone);
export default __webpack_public_path__ + "static/media/speakerCone.0d6129d377879429d0bb563da58cff6f.svg";
export { ForwardRef as ReactComponent };